/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Settings_ActivityInputs */

const en_task_settings_activity = /** @type {(inputs: Task_Settings_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activity`)
};

const pt_br2_task_settings_activity = /** @type {(inputs: Task_Settings_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividade`)
};

/**
* | output |
* | --- |
* | "Activity" |
*
* @param {Task_Settings_ActivityInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_settings_activity = /** @type {((inputs?: Task_Settings_ActivityInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Settings_ActivityInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_settings_activity(inputs)
	return pt_br2_task_settings_activity(inputs)
});